import Layout from "@/layout";
export default {
  path: "Store",
  component: () => import('@/views/AppMain/index'),
  name: "Store",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "门店管理",
    keepAlive: false,
    icon: '1008',
    activeIcon: '1007',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "StoreManagement",
      component: () => import("@/views/HeadOfficeManagement/Store/StoreManagement"),
      name: "StoreManagement",
      meta: {
        title: "门店列表",
        keepAlive: true,
      },
    },
    {
        hidden: true,
        path: "StoreAccountManagement",
        component: () => import("@/views/HeadOfficeManagement/Store/StoreAccountManagement"),
        name: "StoreAccountManagement",
        meta: {
          title: "门店账号管理",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "StoreManagementAdd",
        component: () => import("@/views/HeadOfficeManagement/Store/StoreManagementAdd.vue"),
        name: "StoreManagementAdd",
        meta: {
          title: "新增/编辑门店",
          // keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Store/StoreManagement'
        },
      },
      {
        hidden: true,
        path: "DeliverySettings",
        component: () => import("@/views/HeadOfficeManagement/Store/DeliverySettings"),
        name: "DeliverySettings",
        meta: {
          title: "配送设置",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "DeliveryModelAdd",
        component: () => import("@/views/HeadOfficeManagement/Store/DeliveryModelAdd"),
        name: "DeliveryModelAdd",
        meta: {
          title: "新增/编辑配送模式",
          // keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Store/DeliverySettings'
        },
      },
  ]
};
